import createSagaMiddleware from 'redux-saga';
import { initUserSagas } from './user-sagas';
import { initEntitySagas } from './entity-sagas';
import { initComponentSagas } from './component-sagas'; // create the saga middleware

export var sagaMiddleware = createSagaMiddleware();
var sagas = [initUserSagas, initEntitySagas, initComponentSagas];
var storeInited = false;
/**
 * 注册新的 saga
 * @param {function*} saga
 */

export function registerSaga(saga) {
  if (storeInited) {
    sagaMiddleware.run(saga);
  } else {
    sagas.push(saga);
  }
}
/**
 * 执行所有已注册的 saga
 */

export function runSagas() {
  storeInited = true;

  for (var _i = 0, sagas_1 = sagas; _i < sagas_1.length; _i++) {
    var saga = sagas_1[_i];
    sagaMiddleware.run(saga);
  }
}